import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from "./helpers/locales/en/index.json"
import translationTR from "./helpers/locales/tr/index.json"
import translationFR from "./helpers/locales/fr/index.json"
import translationDE from "./helpers/locales/de/index.json"
import translationES from "./helpers/locales/es/index.json"
import translationIT from "./helpers/locales/it/index.json"
import translationNL from "./helpers/locales/nl/index.json"

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

// eslint-disable-next-line import/no-named-as-default-member
i18n
	// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
	// learn more: https://github.com/i18next/i18next-http-backend
	// want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: 'en',
		debug: false,
		resources: {
			en: { translation: translationEN },
			tr: { translation: translationTR },
			de: { translation: translationDE },
			fr: { translation: translationFR },
			es: { translation: translationES },
			it: { translation: translationIT },
			nl: { translation: translationNL },
		},
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		react: {
			useSuspense: true,
		},
	});

export default i18n;
